export default "__VITE_ASSET__7a322396__"